import axiosInstance from "../api/axiosInstance";

// Giveaways (2026-10-22): contest pages, their entries and the winner draw.
// Super admins only; the server answers 403 with a message for anyone else.
// Every answer is { success, message, data } inside axios's own .data.
const base = "/admin/giveaways";

export const listGiveaways = () => axiosInstance.get(base);

export const createGiveaway = (body) => axiosInstance.post(base, body);

export const getGiveaway = (id) => axiosInstance.get(`${base}/${id}`);

export const updateGiveaway = (id, body) => axiosInstance.put(`${base}/${id}`, body);

export const changeGiveawayStatus = (id, to, reason) =>
  axiosInstance.post(`${base}/${id}/status`, { to, reason });

export const pauseGiveaway = (id, paused, reason) =>
  axiosInstance.post(`${base}/${id}/pause`, { paused, reason });

export const listGiveawayEntries = (id, params) =>
  axiosInstance.get(`${base}/${id}/entries`, { params });

export const updateGiveawayEntry = (id, entryId, body) =>
  axiosInstance.patch(`${base}/${id}/entries/${entryId}`, body);

// CSV: comes back as a file, not JSON.
export const exportGiveawayEntries = (id, params) =>
  axiosInstance.get(`${base}/${id}/export`, { params, responseType: "blob" });

export const drawGiveawayWinner = (id) =>
  axiosInstance.post(`${base}/${id}/draw`, { confirm: "DRAW" });

export const stepGiveawayDraw = (id, seq, body) =>
  axiosInstance.post(`${base}/${id}/draws/${seq}/step`, body);

export const notifyGiveawayDraw = (id, seq) =>
  axiosInstance.post(`${base}/${id}/draws/${seq}/notify`, { confirm: true });

export const retryGiveawayEmails = (id) => axiosInstance.post(`${base}/${id}/emails/retry`);

export const deleteGiveawayTests = (id) => axiosInstance.post(`${base}/${id}/tests/delete`);

export const purgeGiveaway = (id, body) => axiosInstance.post(`${base}/${id}/purge`, body);
